"use client"

// TEMPORARY MIGRATION CODE — remove with the rest of lib/migration/.
import { track } from "@/lib/analytics/client"

type LegacyHashRedirectedEvent = {
  name: "Migration Legacy Hash Redirected"
  properties: { legacyPath: string }
}

// Fires when a user arrives via a legacy ClientConsole `#/…` bookmark and is
// successfully redirected to the equivalent new path. `legacyPath` is the path
// segment of the hash without the leading `#` (e.g. `/recordings/abc123`).
export const trackLegacyHashRedirected = (legacyPath: string) =>
  track<LegacyHashRedirectedEvent>({
    name: "Migration Legacy Hash Redirected",
    properties: { legacyPath },
  })
